import React, { Component, useEffect, useState } from "react";
import {
  Spin,
  Card,
  Col,
  Table,
  Button,
  Modal,
  Row,
  Form,
  Input,
  DatePicker,
  Select,
  Space,
  Typography,
} from "antd";

import ColumnsCashFlow from "./columns-table";
import ColumnsFooterCashFlow from "./columns-footer";
import {
  getBanks,
  getCashFlowBalance,
  getCashFlowByType,
  getCashFlowBalanceData,
} from "services/dashboard/dashboard-service";
import { notificationErroInternal } from "util/api-utils";
import FusionCharts from "fusioncharts";
import Charts from "fusioncharts/fusioncharts.charts";
import Powercharts from "fusioncharts/fusioncharts.powercharts";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.gammel";
import ReactFC from "react-fusioncharts";
import ReactFusioncharts from "react-fusioncharts";
import { mountDataColumnAndLineCashFlow } from "./func-chart";
import dayjs from "dayjs";
import moment from "moment";
import Highlighter from "react-highlight-words";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { formatCurrency } from "util/format";
import { ExclamationCircleFilled, SearchOutlined } from "@ant-design/icons";
import { getStatus } from "services/client/client-service";
import {
  ArrowRight,
  CalendarDays,
  FileInput,
  Landmark,
  Layers2,
  Maximize,
  Repeat,
} from "lucide-react";
import {
  Bar,
  CartesianGrid,
  ComposedChart,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

dayjs.extend(customParseFormat);

ReactFC.fcRoot(FusionCharts, Charts, Powercharts, FusionTheme);
FusionCharts.options["license"] = false;

const { info } = Modal;
const dateFormat = "MM/YYYY";
const font = '"Montserrat", sans-serif';
const { Text } = Typography;
const padColor = "#EC6D62";
const receiveColor = "#0071FF";
const profitColor = "#FF9900";

const CashFlowClient = () => {
  const [loadingCashFlow, setLoadingCashFlow] = useState(true);
  const [filterStartDate, setStartDate] = useState(moment().format(dateFormat));
  const [filterEndDate, setEndDate] = useState(moment().format(dateFormat));
  const [banks, setBanks] = useState([]);
  const [filterBanks, setFilterBanks] = useState([]);
  const [filterStatus, setFilterStatus] = useState([]);
  const [status, setStatus] = useState([]);
  const [dataPaid, setDataPaid] = useState({
    amout: 0,
    data: [],
  });

  const [dataReceive, setDataReceive] = useState({ amout: 0, data: [] });

  const [dataCashFlow, setDataCashFlow] = useState({
    amout: 0,
    paid: 0,
    receive: 0,
    data: [],
    banks: [],
  });

  const [dataChart, setDataChart] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = React.useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loadingPaidModal, setLoadingPaidModal] = useState(true);
  const [loadingReceiveModal, setLoadingReceiveModal] = useState(true);
  const formRef = React.useRef(null);

  useEffect(() => {
    getStatus()
      .then((res) => {
        let selectStatus = res
          .filter((item) => item.name != "Cancelado")
          .map((obj) => ({
            value: obj.name,
            label: obj.name,
          }));

        let resIdStatus = res
          .filter((f) => f.name != "Atrasado" && f.name != "Cancelado")
          .map((item) => item.name);

        setFilterStatus(resIdStatus);

        setStatus(selectStatus);
        getBanks().then((res) => {
          let selectBank = res.map((obj) => ({
            value: obj.codeAccount,
            label: obj.description,
          }));
          selectBank.push({ value: "WITHOUT_BANK", label: "Em Branco" });

          let resIdBank = res
            .filter((item) => item.sumAmount == true)
            .map((item) => item.codeAccount);
          resIdBank.push("WITHOUT_BANK");

          setFilterBanks(resIdBank);
          setBanks(selectBank);
          formRef.current?.setFieldsValue({
            banks: resIdBank,
            status: resIdStatus,
          });

          getDataBalance(resIdStatus, resIdBank);
        });
      })

      .catch((err) => {
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }, []);

  function getDataBalance(filterStatus, filterBanks) {
    const filter = {
      start: filterStartDate,
      end: filterEndDate,
      banks: filterBanks,
      status: filterStatus,
    };
    getCashFlowBalance(filter)
      .then((res) => {
        res.data = res.data.map((obj) => ({
          ...obj,
          receiveString: formatCurrency(obj.receive),
          paidString: formatCurrency(obj.paid),
          profitString: formatCurrency(obj.profit),
        }));
        setLoadingCashFlow(false);
        setDataCashFlow(res);

        setDataChart(res.data);
      })
      .catch((err) => {
        setLoadingCashFlow(false);

        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex, tittle) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Buscar ${tittle}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Limpar
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Fechar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const getCashFlow = () => {
    let columnFilter = ColumnsCashFlow.cashFlow.map((item) => ({
      ...item,
      ...getColumnSearchProps(item.dataIndex, item.title),
    }));

    return (
      <Table
        columns={columnFilter}
        dataSource={dataCashFlow.data}
        pagination={{ pageSize: 10 }}
        locale={{
          emptyText: "Sem registro",
        }}
        footer={() => (
          <Table
            showHeader={false}
            columns={ColumnsFooterCashFlow.cashFlow}
            dataSource={[dataCashFlow]}
            pagination={false}
          />
        )}
      />
    );
  };

  const getCashFlowChart = (height) => {
    return (
      <div>
        <ReactFusioncharts
          type="msstackedcolumn2dlinedy"
          width="100%"
          height={600}
          id="chartCashFlowDaily"
          dataFormat="JSON"
          dataSource={mountDataColumnAndLineCashFlow(dataChart)}
          fcEvent-dataplotClick={(el, d) => {
            chartClickEvent(el, d, formRef);
          }}
        />
      </div>
    );
  };

  function chartClickEvent(payload) {
    const status = formRef.current.getFieldValue("status");
    const banks = formRef.current.getFieldValue("banks");
    const filterPaid = {
      start: payload.dueDate,
      end: payload.dueDate,
      type: "CONTA_A_PAGAR",
      banks: banks,
      status: status,
    };
    setIsModalOpen(true);
    setLoadingPaidModal(true);
    setLoadingReceiveModal(true);
    setDataPaid({ amout: 0, data: [] });
    setDataReceive({ amout: 0, data: [] });

    getCashFlowBalanceData(filterPaid)
      .then((res) => {
        setLoadingPaidModal(false);
        setDataPaid(res);
      })
      .catch((err) => {
        setLoadingPaidModal(false);

        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
    const filterReceive = {
      start: payload.dueDate,
      end: payload.dueDate,
      type: "CONTA_A_RECEBER",
      banks: banks,
      status: status,
    };
    getCashFlowBalanceData(filterReceive)
      .then((res) => {
        setLoadingReceiveModal(false);
        setDataReceive(res);
      })
      .catch((err) => {
        setLoadingReceiveModal(false);

        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }

  function showConfirm(title, div, icon) {
    info({
      title: (
        <span style={{ fontFamily: font }}>
          {icon}
          {title}
        </span>
      ),
      icon: null,
      content: div,
      width: "90%",
      centered: true,
      getContainer() {},
      onOk() {},
    });
  }
  const divCashFlow = getCashFlow();

  const divChart = getCashFlowChart("380%");

  const refreshData = () => {
    setLoadingCashFlow(true);
    if (!filterStatus.includes("Conciliado")) {
      filterStatus.push("Conciliado");
    }
    if (!filterStatus.includes("Quitado")) {
      filterStatus.push("Quitado");
    }
    getDataBalance(filterStatus, filterBanks);
  };

  const setFilterStartDate = (e) => {
    if (e == null) {
      setStartDate(moment().format(dateFormat));
      setEndDate(moment().format(dateFormat));
    } else {
      setStartDate(e.format(dateFormat));
      setEndDate(e.format(dateFormat));
    }
  };
  const setFilterBank = (e) => {
    if (e.length == 0) {
      let selectBank = banks.map((obj) => obj.value);
      setFilterBanks(selectBank);
    } else {
      setFilterBanks(e);
    }
  };
  const changeFilterStatus = (e) => {
    if (e.length == 0) {
      let statusFilter = status.map((obj) => obj.value);
      setFilterStatus(statusFilter);
    } else {
      setFilterStatus(e);
    }
  };
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const selectPropsBank = {
    mode: "multiple",
    style: {
      width: "100%",
      fontFamily: font,
    },
    defaultValue: filterBanks,
    options: banks,
    onChange: (newValue) => {
      setFilterBank(newValue);
    },
    placeholder: "Bancos",
    maxTagCount: "responsive",
  };

  const selectPropsStatus = {
    mode: "multiple",
    style: {
      width: "100%",
      fontFamily: font,
    },
    options: status,
    onChange: (newValue) => {
      changeFilterStatus(newValue);
    },
    placeholder: "Status",
    maxTagCount: "responsive",
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div
          className="custom-tooltip"
          style={{
            backgroundColor: "#fff",
            padding: "10px",
            border: "1px solid #ccc",
            borderRadius: "6px",
            fontFamily: font,
          }}
        >
          <p className="intro">{`Dia: ${label}`}</p>
          <p className="intro">
            Despesa:{" "}
            <span style={{ color: padColor }}>
              {formatCurrency(payload[0]?.value)}
            </span>
          </p>
          <p className="intro">
            Receita:{" "}
            <span style={{ color: receiveColor }}>
              {formatCurrency(payload[1]?.value)}
            </span>
          </p>
          <p className="intro">
            Saldo Final:{" "}
            <span style={{ color: profitColor }}>
              {formatCurrency(payload[2]?.value)}
            </span>
          </p>
        </div>
      );
    }

    return null;
  };
  const chartReceivePaid = () => {
    return (
      <ResponsiveContainer
        width="100%"
        height={697}
        style={{ fontFamily: font }}
      >
        <ComposedChart
          data={dataChart}
          margin={{ top: 20, right: 30, left: 50, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="dueDate"
            tickFormatter={(value) => value.substring(0, 2)}
          />
          <YAxis tickFormatter={(value) => formatCurrency(value)} />

          <Tooltip content={<CustomTooltip />} />
          <Legend align="left" />
          <Bar
            name="Despesa"
            dataKey="paid"
            fill={padColor}
            onClick={(e) => {
              const { payload } = e;
              chartClickEvent(payload);
            }}
          />
          <Bar
            name="Receita"
            dataKey="receive"
            fill={receiveColor}
            onClick={(e) => {
              const { payload } = e;

              chartClickEvent(payload);
            }}
          />
          <Line
            name="Saldo Final"
            type="monotone"
            dataKey="profit"
            stroke={profitColor}
          />
        </ComposedChart>
      </ResponsiveContainer>
    );
  };

  return (
    <div className="container-cash-flow-client">
      <Spin spinning={loadingCashFlow} size={"large"}>
        <Row gutter={24} style={{ padding: "10px" , marginBottom: '-15px'}}>
          <Form ref={formRef} width="100%">
            <Space
              style={{ flex: "1 1 150px", minWidth: "150px", maxWidth: "12%" }}
            >
              <DatePicker
                defaultValue={dayjs(filterStartDate, dateFormat)}
                format={dateFormat}
                allowClear={false}
                style={{ width: "100%", fontFamily: font }}
                picker="month"
                placeholder="Mês"
                onChange={setFilterStartDate}
                suffixIcon={<CalendarDays size={18} />}
              />
            </Space>
            <Space
              style={{
                flex: "1 1 400px",
                minWidth: "400px",
                maxWidth: "20%",
                width: "100%",
              }}
            >
              <Form.Item style={{ width: "100%" }} name="banks">
                <Select
                  showArrow={true}
                  suffixIcon={<Landmark size={18} />}
                  {...selectPropsBank}
                />
              </Form.Item>
            </Space>
            <Space
              style={{
                flex: "1 1 400px",
                minWidth: "400px",
                maxWidth: "20%",
                width: "100%",
              }}
            >
              <Form.Item style={{ width: "100%" }} name="status">
                <Select
                  showArrow={true}
                  suffixIcon={<Repeat size={18} />}
                  {...selectPropsStatus}
                />
              </Form.Item>
            </Space>
            <Space>
              <Button
                style={{ fontFamily: font }}
                type="primary"
                icon={
                  <ArrowRight
                    size={18}
                    style={{ marginBottom: "-3px", marginRight: "7px" }}
                  />
                }
                onClick={refreshData}
              >
                Filtrar
              </Button>
            </Space>
          </Form>
        </Row>

        <Row gutter={[24, 24]} style={{  marginLeft: "0px" }}>
          <Space
            direction="vertical"
            size={"small"}
            style={{ flex: "1 1 300px", minWidth: "300px", maxWidth: "50%" }}
          >
            <Card
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <FileInput
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "14px", fontFamily: font }}>
                      Receita e Despesa
                    </Text>
                  </div>
                  <Button
                    onClick={() =>
                      showConfirm(
                        "Receita e Despesa",
                        chartReceivePaid(),
                        <FileInput
                          size={20}
                          style={{
                            marginRight: "10px",
                            marginBottom: "-3px",
                          }}
                        />
                      )
                    }
                    style={{ fontFamily: font, marginLeft: "10px" }}
                  >
                    <Maximize size={20} />
                  </Button>
                </div>
              }
              style={{ width: "100%" }}
            >
              {chartReceivePaid()}
            </Card>
          </Space>
          <Space
            direction="vertical"
            size={"small"}
            style={{ flex: "1 1 500px", minWidth: "500px", maxWidth: "50%" }}
          >
            <Card
              id="card-table"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <Layers2
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "15px", fontFamily: font }}>
                      Fluxo de Caixa
                    </Text>
                  </div>
                  <Button
                    onClick={() =>
                      showConfirm(
                        "Fluxo de Caixa",
                        getCashFlow(),
                        <Layers2
                          size={20}
                          style={{
                            marginRight: "10px",
                            marginBottom: "-3px",
                          }}
                        />
                      )
                    }
                    style={{ fontFamily: font, marginLeft: "10px" }}
                  >
                    <Maximize size={20} />
                  </Button>
                </div>
              }
              style={{ height: "800px" }}
              bordered={false}
            >
              {getCashFlow()}
            </Card>
          </Space>
        </Row>

        <Modal
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          okText="Ok"
          cancelText="Cancelar"
          width={"50%"}
        >
          <div style={{ textAlign: "center" }}>
            <Table
              title={() => <strong>Contas à Pagar</strong>}
              loading={loadingPaidModal}
              columns={ColumnsCashFlow.cashFlowDaily}
              dataSource={dataPaid.data}
              pagination={{ pageSize: 5 }}
              locale={{
                emptyText: "Sem registro",
              }}
              footer={() => (
                <Table
                  showHeader={false}
                  columns={ColumnsFooterCashFlow.cashFlowDaily}
                  dataSource={[dataPaid]}
                  pagination={false}
                />
              )}
            />
            <Table
              title={() => <strong>Contas à Receber</strong>}
              loading={loadingReceiveModal}
              columns={ColumnsCashFlow.cashFlowDaily}
              dataSource={dataReceive.data}
              pagination={{ pageSize: 5 }}
              locale={{
                emptyText: "Sem registro",
              }}
              footer={() => (
                <Table
                  showHeader={false}
                  columns={ColumnsFooterCashFlow.cashFlowDaily}
                  dataSource={[dataReceive]}
                  pagination={false}
                />
              )}
            />
          </div>
        </Modal>
      </Spin>
    </div>
  );
};
export default CashFlowClient;
